var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.2388 11.5H18.7625C14.9625 11.5 12.75 13.725 12.75 17.5375V30.45C12.75 34.325 14.9625 36.5 18.7625 36.5H29.2388C33.1 36.5 35.25 34.325 35.25 30.45V17.5375C35.25 13.725 33.1 11.5 29.2388 11.5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3028 18.6967C29.9992 19.3931 30.5517 20.2199 30.9286 21.1299C31.3055 22.0398 31.4995 23.0151 31.4995 24C31.4995 24.9849 31.3055 25.9602 30.9286 26.8701C30.5517 27.7801 29.9992 28.6069 29.3028 29.3033M29.3028 29.3033L26.9453 26.9458M29.3028 29.3033L31.4994 31.5M26.9461 21.0533C27.3331 21.4403 27.6402 21.8996 27.8496 22.4052C28.0591 22.9108 28.1669 23.4527 28.1669 24C28.1669 24.5473 28.0591 25.0892 27.8496 25.5948C27.6402 26.1004 27.3331 26.5597 26.9461 26.9467L24.5886 24.5892M24.5886 24.5892C24.6682 24.5123 24.7317 24.4203 24.7754 24.3187C24.819 24.217 24.842 24.1076 24.843 23.997C24.844 23.8864 24.8229 23.7766 24.781 23.6742C24.7391 23.5718 24.6772 23.4787 24.5989 23.4005C24.5207 23.3223 24.4277 23.2604 24.3252 23.2185C24.2228 23.1766 24.1131 23.1555 24.0024 23.1565C23.8918 23.1574 23.7824 23.1804 23.6808 23.2241C23.5791 23.2678 23.4872 23.3312 23.4103 23.4108M24.5886 24.5892L23.4103 23.4108M21.0528 26.9467C20.414 26.3096 20.0003 25.4817 19.8744 24.5883M18.6961 29.3033C17.708 28.3157 17.0153 27.0717 16.6962 25.7115C16.3772 24.3513 16.4444 22.929 16.8903 21.605M23.4103 23.4108L16.4994 16.5",
    stroke: "#E5B910",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineWithBg);
export default __webpack_public_path__ + "static/media/offline-with-bg.fb06ae3557ec8a3842c4be86ea5f8d3b.svg";
export { ForwardRef as ReactComponent };